import { Box, Button, Stack } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import dayjs from 'dayjs'
import { downloadSessionResults, listSyncJobs } from 'api'
import Header from 'components/Header'

const SyncOrderHistory = () => {
  const [rows, setRows] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const jobs = await listSyncJobs()
        setRows(
          jobs.map((j: any, idx: number) => ({
            id: j._id || idx,
            sessionId: j.sessionId,
            company: j.company,
            triggeredBy: j.triggeredBy,
            totalOrders: j.totalOrders,
            successCount: j.successCount,
            failureCount: j.failureCount,
            skippedCount: j.skippedCount,
            status: j.status || 'IN_PROGRESS',
            createdAt: j.createdAt,
            endedAt: j.endedAt
          }))
        )
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const columns: GridColDef[] = useMemo(
    () => [
      { field: 'sessionId', headerName: 'Session ID', flex: 1, minWidth: 200 },
      { field: 'company', headerName: 'Company', width: 120 },
      { field: 'triggeredBy', headerName: 'Triggered By', width: 140 },
      { field: 'totalOrders', headerName: 'Total', width: 90, type: 'number' },
      {
        field: 'successCount',
        headerName: 'Success',
        width: 100,
        type: 'number'
      },
      {
        field: 'failureCount',
        headerName: 'Failure',
        width: 100,
        type: 'number'
      },
      {
        field: 'skippedCount',
        headerName: 'Skipped',
        width: 100,
        type: 'number'
      },
      { field: 'status', headerName: 'Status', width: 130 },
      {
        field: 'createdAt',
        headerName: 'Started',
        width: 170,
        valueGetter: (params: any) =>
          params ? dayjs(params).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      {
        field: 'endedAt',
        headerName: 'Ended',
        width: 170,
        valueGetter: (params: any) =>
          params ? dayjs(params).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      {
        field: 'actions',
        headerName: 'Actions',
        width: 200,
        sortable: false,
        filterable: false,
        renderCell: params => {
          const sessionId = params.row.sessionId
          const onDownload = async () => {
            const blob = await downloadSessionResults(sessionId)
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `sync-results-${sessionId}.xlsx`
            a.click()
            window.URL.revokeObjectURL(url)
          }
          return (
            <Button size='small' variant='outlined' onClick={onDownload}>
              Download
            </Button>
          )
        }
      }
    ],
    []
  )

  return (
    <Box>
      <Header />
      <Box p={2}>
        <DataGrid rows={rows} columns={columns} loading={loading} />
      </Box>
    </Box>
  )
}

export default SyncOrderHistory
